<template>
<div v-if="this.$store.state.printReceiptLoading" class="container">

  <svg xmlns="http://www.w3.org/2000/svg" class="svg-success" viewBox="0 0 24 24">
    <g stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10">
      <circle class="success-circle-outline" cx="12" cy="12" r="11.5"/>
      <circle class="success-circle-fill" cx="12" cy="12" r="11.5"/>
      <polyline class="success-tick" points="17,8.5 9.5,15.5 7,13"/>
    </g>
  </svg>

  <h2> Payment Successfull! </h2>
</div>

<div v-else>
  <div class="heading-part"><p>Thank you for your payment!</p></div>
  <div class="heading-part bottom-padding"><p>You may print this page as receipt for your records.</p></div>
  <table cellpadding="5">
    <tr>
      <td class="item1">BILLED TO:</td>
      <td class="item2">{{ this.$store.state.printReceiptData.customer_details.name }}</td>
    </tr>
    <tr v-if="this.$store.state.printReceiptData.customer_details.email">
      <td class="item1">BILLED TO EMAIL:</td>
      <td class="item2">{{ this.$store.state.printReceiptData.customer_details.email }}</td>
    </tr>
    <tr>
      <td class="item1">BILLED TO ADDRESS:</td>
      <td class="item2">
        <span>{{ this.$store.state.printReceiptData.customer_details.address_line1 | comma }}</span>
        <span>{{ this.$store.state.printReceiptData.customer_details.address_line2 | comma }}</span>
        <span>{{ this.$store.state.printReceiptData.customer_details.city | comma }}</span>
        <span>{{ this.$store.state.printReceiptData.customer_details.state_code | comma }}</span>
        <span>{{ this.$store.state.printReceiptData.customer_details.country_code | comma}}</span>
        <span>{{ this.$store.state.printReceiptData.customer_details.zip }}</span>
      </td>
    </tr>
    <tr v-for="(item, key, index) in this.$store.state.printReceiptData.order_form" :key="index">
      <td class="item1">{{ key | capitalize }}</td>
      <td class="item2">{{ item }}</td>
    </tr>
    <tr>
      <td class="item1">DATE PAID:</td>
      <td class="item2">{{ this.$store.state.printReceiptData.customer_details.date_paid }}</td>
    </tr>
    <tr v-if="this.$store.state.printReceiptData.customer_details.last4">
      <td class="item1">LAST 4 DIGITS OF CARD:</td>
      <td class="item2">{{ "*" + this.$store.state.printReceiptData.customer_details.last4 }}</td>
    </tr>
    <tr>
      <td class="item1">AMOUNT PAID:</td>
      <td class="item2">{{ (this.$store.state.printReceiptData.customer_details.amount/100) | toCurrency }}</td>
    </tr>
    <tr v-if="this.$store.state.printReceiptData.customer_details.payment_source">
      <td class="item1">PAYMENT SOURCE:</td>
      <td class="item2">{{ this.$store.state.printReceiptData.customer_details.payment_source }}</td>
    </tr>
  </table>
</div>

</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'IconTotemSuccess',
  filters: {
    capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.toUpperCase();
    },
    toCurrency(value) {
      if (typeof value !== "number") {
          return value;
      }
      var formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2
      });
      return formatter.format(value);
    },
    comma(value) {
      if(!value) return '';
      value = value + ', ';
      return value;
    }
  },
  computed: {
    ...mapState('PaymentForm', [
      'orderData',
    ]),
  },
  methods: {
    ...mapActions(['getOrderPrintData']),
  },
  created() {
    this.getOrderPrintData();
  }
};
</script>


<style lang="scss" scoped>

table {
  width: 100%;
  border: none;
}

.heading-part {
  text-align: start;
  color: blue;
  font-weight: bold;
}

.item1 {
  text-align: start;
  color: blue;
  font-weight: bold;
}

.item2 {
  color: blue;
  text-align: start;
  font-weight: 500;
}

.bottom-padding {
  padding-bottom: 60px;
}

.grid-container {
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 10px;
  padding: 10px;
}

.container {
  width: 150px;
  margin: 50px auto;
}
.svg-success {
  display: inline-block;
  vertical-align: top;
  height: 100px;
  width: 100px;
  opacity: 1;
  overflow: visible;

  @keyframes success-tick {
    0% {
      stroke-dashoffset: 16px;
      opacity: 1
    }

    100% {
      stroke-dashoffset: 31px;
      opacity: 1
    }
  }

  @keyframes success-circle-outline {
    0% {
      stroke-dashoffset: 72px;
      opacity: 1
    }

    100% {
      stroke-dashoffset: 0px;
      opacity: 1
    }
  }

  @keyframes success-circle-fill {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  .success-tick {
    fill: none;
    stroke-width: 1px;
    stroke: #ffffff;
    stroke-dasharray: 15px, 15px;
    stroke-dashoffset: -14px;
    animation: success-tick 450ms ease 1400ms forwards;
    opacity: 0;
  }

  .success-circle-outline {
    fill: none;
    stroke-width: 1px;
    stroke: #81c038;
    stroke-dasharray: 72px, 72px;
    stroke-dashoffset: 72px;
    animation: success-circle-outline 300ms ease-in-out 800ms forwards;
    opacity: 0;
  }

  .success-circle-fill {
    fill: #81c038;
    stroke: none;
    opacity: 0;
    animation: success-circle-fill 300ms ease-out 1100ms forwards;
  }

  // Can't animate stroke-dashoffset on IE 10 and 11, just show svg instead
  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    .success-tick {
      stroke-dasharray: 0;
      stroke-dashoffset: 0;
      animation: none;
      opacity: 1;
    }

    .success-circle-outline {
      stroke-dasharray: 0;
      stroke-dashoffset: 0;
      animation: none;
      opacity: 1;
    }

    .success-circle-fill {
      animation: none;
      opacity: 1;
    }
  }
}


</style>
